<template>
  <div>
    <header>
      <div class="container">
        <div class="row">
          <div class="col d-flex justify-content-center logo">
            <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/logo-tokiomarine.svg" alt="Tokio Marine Seguradora  - Fluxo Integrações"
              title="Tokio Marine Seguradora  - Fluxo Integrações">
          </div>
        </div>
      </div>
    </header>
    <section class="banner">
      <span></span>
      <!-- <h2>BEM VINDO(A) AO</h2> -->
      <h1>FLUXO DE INTEGRAÇÕES</h1>
      <hr class="divider">
    </section>
    <nav>
      <div class="container">
        <div class="row">
          <div class="col d-flex justify-content-center">
            <button :class="{ active: isActive[0] }" @click.prevent="toggleButton(0)" class="me-4">ADESÃO</button>
            <button :class="{ active: isActive[1] }" @click.prevent="toggleButton(1)">NOVA INTEGRAÇÃO</button>
          </div>
        </div>
      </div>
    </nav>
    <main>
      <component :is="currentComponent"></component>
    </main>
    <footer>© Tokio Marine 2024 - Todos os direitos reservados.</footer>
  </div>
</template>

<script>
import Adesao from '@/views/fluxo/adesao/Adesao.vue';
import NovaIntegracao from '@/views/fluxo/nova-integracao/NovaIntegracao.vue';

export default {
  data() {
    return {
      currentComponent: null,
      isActive: [true, false]
    };
  },

  methods: {
    getParametro() {
      if (this.$route.query.parametro == "col") {
       //console.log("col")
       document.querySelector("header").classList.add("col");
       document.querySelector(".banner").classList.add("col");
      }
    },
    
    async changeComponent(componentName) {
      try {
        switch (componentName) {
          case Adesao:
            this.currentComponent = Adesao;
            document.querySelector("body").classList.add("fluxo")
            document.querySelector("body").classList.remove("fluxo-nova-integracao")
            break;
          case NovaIntegracao:
            this.currentComponent = NovaIntegracao;
            document.querySelector("body").classList.add("fluxo-nova-integracao")
            document.querySelector("body").classList.remove("fluxo")
            break;
        }
      } catch (error) {
        console.error(`Erro ao carregar o componente '${componentName}':`, error);
      }
    },

    toggleButton(index) {
      this.isActive = this.isActive.map((_, i) => i === index);

      if (index === 0) {
        this.changeComponent(Adesao)
      } else {
        this.changeComponent(NovaIntegracao)
      }
    }
  },

  mounted() {
    this.changeComponent(Adesao);
    document.querySelector("body").classList.add("fluxo");
    this.getParametro();
  }
};

</script>
<style>
@import '/massificados/corporativo/gerenciador-parceiros-ui/fluxo/css/fluxo.css';
</style>